/**
 * Mémorisation des tutoriels vus, scopée par compte : plusieurs utilisateurs partagent
 * souvent le même navigateur. Le flag survit à la déconnexion, qui ne purge que le token,
 * `accountStorage` et `cookieConsent`.
 */
import { accountKey } from "../../utils/accountFlags";

const PREFIX = "tour-seen";

/** Ancien flag global du tutoriel dashboard, relu pour ne pas le rejouer. */
const LEGACY_DASHBOARD_KEY = "dashboard-tutorial-seen";

const storageKey = (id: string) => `${PREFIX}:${accountKey()}:${id}`;

export const hasSeenTour = (id: string): boolean => {
  try {
    if (localStorage.getItem(storageKey(id))) return true;
    return id === "dashboard" && !!localStorage.getItem(LEGACY_DASHBOARD_KEY);
  } catch {
    return false;
  }
};

export const markTourSeen = (id: string) => {
  try {
    localStorage.setItem(storageKey(id), "1");
  } catch {
    // Navigation privée ou storage plein : le tour se rejouera, rien de bloquant.
  }
};
